import React from 'react';
import  { setupAPIclient } from '../../services/setupAPIclientAuth';
import { toast } from "react-toastify";
import { useState } from 'react';
import {useNavigate} from 'react-router-dom';
import LocalStorage from '../../helpers/localstorage';

function AuthenticationMasterPage() {

  const navigate = useNavigate();

  const [showDivregistered, showDivRegistered] = useState(false);
  const [formData, setFormData] = useState<{
    email: string;
    password: string;
  }>({
    email: '',
    password: ''
  });
  
    function modify_form()  {

      if(showDivregistered){
        showDivRegistered(false) 
      }else {
        showDivRegistered(true) 
      }
      
    }

    function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>){
      const { name, value } = e.target;  
      setFormData({
        ...formData,  
        [name]: value, 
      });
    };
   

    async function handleSubmitlogin(e: React.FormEvent<HTMLFormElement>){
      e.preventDefault();
      try {
        const ApiClient = setupAPIclient();
        const response = await ApiClient.post("/login_master", {
          "password": formData.password,
          "email": formData.email
        });
        if (response && response.data) {

            toast.success('Senha e email confirmados');
            const storage = new LocalStorage()
            
            storage.saveAuthTokenMaster(response.data.token)

            navigate("/HomeMasterPage")

        } else {
            toast.error('Erro ao tentar login, tente novamente.');
        }
      } catch (error) {
        toast.error('Erro ao tentar login, tente novamente.');
      }
    };

  return (
    <div className="auth-shell d-flex align-items-center justify-content-center">
      <div className="auth-panel container-fluid p-0">
        <div className="row g-0">
          <div className="col-lg-6">
            <div className="auth-brand d-flex flex-column justify-content-between">
              <div>
                <span className="auth-kicker auth-brand-badge">
                  Acesso corporativo
                </span>
                <h1>Track EPI</h1>
                <p>
                  Ambiente do administrador master para acompanhar acessos,
                  estrutura da operação e contas vinculadas ao sistema.
                </p>
              </div>

              <div className="auth-brand__stats">
                <div>
                  <strong>Master</strong>
                  <span>Painel central de gestão</span>
                </div>
                <div>
                  <strong>Seguro</strong>
                  <span>Autenticação por credencial</span>
                </div>
                <div>
                  <strong>Track</strong>
                  <span>Padrão visual do sistema</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="auth-form-wrap d-flex align-items-center h-100">
              <div className="w-100">
                <span className="auth-kicker">Área administrativa</span>
                <h2 className="auth-heading">Entrar no painel master</h2>
                <p className="auth-copy">
                  Acesse com seu email corporativo para continuar.
                </p>

                <div className="auth-form-card">
                  <form method="POST" onSubmit={handleSubmitlogin}>
                    <div className="auth-input-group">
                      <label htmlFor="login">Email</label>
                      <div className="auth-input-shell">
                        <span><i className="bi bi-envelope-at"></i></span>
                        <input
                          type="text"
                          name="email"
                          placeholder="Somente email"
                          id='login'
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="auth-input-group">
                      <label htmlFor="password">Senha</label>
                      <div className="auth-input-shell">
                        <span><i className="bi bi-shield-lock"></i></span>
                        <input
                          type="password"
                          name="password"
                          required
                          placeholder="Sua senha"
                          id='password'
                          value={formData.password}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <button type="submit" className="auth-submit">
                      Entrar
                    </button>
                  </form>

                  <button
                    type="button"
                    className="auth-toggle auth-link-button"
                    onClick={modify_form}
                  >
                    Cadastrar-se
                  </button>

                  {showDivregistered && (
                    <div className="auth-helper-card mt-3">
                      O cadastro master é liberado internamente. Se você precisa
                      de acesso, solicite a criação da conta ao administrador
                      responsável.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthenticationMasterPage;
